__turbopack_context__.v({
  "icon": "Navbar-module-sass-module__K9-CDW__icon",
  "navButton": "Navbar-module-sass-module__K9-CDW__navButton",
  "navButtonAccent": "Navbar-module-sass-module__K9-CDW__navButtonAccent",
  "navbar": "Navbar-module-sass-module__K9-CDW__navbar",
  "wrapper": "Navbar-module-sass-module__K9-CDW__wrapper",
});
